import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';

const GRADUATION_TARGET = 10;

export default function UsedSellerOnboardingBar({ user }) {
  const [onboarding, setOnboarding] = useState(null);

  useEffect(() => {
    const ob = user?.usedSellerDetails?.sellerOnboarding;
    if (ob) {
      setOnboarding(ob);
      return;
    }
    if (user?.role !== 'used_vendor') return;

    (async () => {
      try {
        const res = await api.get('/used-seller/kyc/state', { withCredentials: true });
        setOnboarding(res.data?.onboarding);
      } catch {
        /* ignore */
      }
    })();
  }, [user]);

  if (!onboarding?.active) return null;

  const completed = Number(onboarding.completedOrders) || 0;
  const pct = Math.min(100, Math.round((completed / GRADUATION_TARGET) * 100));

  return (
    <div className="mx-4 mt-4 mb-2 rounded-xl border border-emerald-500/30 bg-emerald-950/40 px-4 py-3">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-sm font-semibold text-emerald-100">Seller onboarding</p>
        <p className="text-xs text-emerald-300">
          {completed} of {GRADUATION_TARGET} orders to graduation
        </p>
      </div>
      <div className="h-2 rounded-full bg-slate-700 overflow-hidden">
        <div
          className="h-full bg-emerald-500 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="mt-2 text-xs text-slate-400">
        +50% SLA buffer active · Strike penalties suppressed during onboarding
      </p>
    </div>
  );
}
